import React from "react";
import Home from "./components/Home";
import "bootstrap/dist/css/bootstrap.min.css";

export default function App() {
  return  <Home /> 
};